
export default {

    stockistPackages(state,data){
        state.stockistPackages = data
    },

    stockistPackage(state,data){
        state.stockistPackage = data
    }
}